import React from "react";

import { MembershipCard } from "../../../components/admin/u1/membership/MembershipCard";
import "../../../components/common/u1/tokens.css";

/* u1 Membership — TIP-633.
 *
 * The screen is one block of largely static content, so the page is just the
 * mount point; MembershipCard holds the states and the data handling. Distinct
 * from the public checkout at /membership/:companyId, which this ticket does
 * not touch.
 */
export default function DashboardMembership() {
  return <MembershipCard />;
}
